import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

let unauthorizedHandler = null;

export const setUnauthorizedHandler = (handler) => {
	unauthorizedHandler = handler;
};

const attachToken = (config) => {
	const token = localStorage.getItem("token");
	if (token) {
		try {
			config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
		} catch {
			config.headers.Authorization = `Bearer ${token}`;
		}
	}
	return config;
};

api.interceptors.request.use(attachToken, (error) => Promise.reject(error));

api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config || {};
		const status = error?.response?.status;
		const isRefreshCall = String(originalRequest?.url || "").includes("/auth/refresh_token");

		const hasToken = Boolean(localStorage.getItem("token"));

		// Só tenta refresh em 401 com token. Sem token / 403 de permissão não é overlay.
		if (status === 401 && hasToken && !originalRequest._retry && !isRefreshCall) {
			originalRequest._retry = true;
			try {
				const { data } = await api.post("/auth/refresh_token");
				if (data?.token) {
					localStorage.setItem("token", JSON.stringify(data.token));
					api.defaults.headers.Authorization = `Bearer ${data.token}`;
					originalRequest.headers = originalRequest.headers || {};
					originalRequest.headers.Authorization = `Bearer ${data.token}`;
					return api(originalRequest);
				}
			} catch (_) {
				localStorage.removeItem("token");
				api.defaults.headers.Authorization = undefined;
				if (typeof unauthorizedHandler === "function") {
					unauthorizedHandler();
				}
			}
		} else if (status === 401 && !hasToken && typeof unauthorizedHandler === "function") {
			unauthorizedHandler();
		}

		return Promise.reject(error);
	}
);

export default api;
